// extracted by mini-css-extract-plugin
export default {"wrapper":"FlatTreeSelect_wrapper__lXLRd"};